import { apiClient } from './api';
import type { Review } from '@/types';

export const reviewService = {
  async createReview(params: { orderId: string; rating: number; comment?: string }): Promise<Review> {
    const response = await apiClient.post<Review>('/reviews', {
      orderId: params.orderId,
      rating: params.rating,
      comment: params.comment,
    });

    return response.data.data;
  },

  /**
   * Get restaurant reviews
   */
  async getRestaurantReviews(params: { page?: number; limit?: number } = {}): Promise<{
    reviews: Review[];
    total: number;
    page: number;
    limit: number;
  }> {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());

    const queryString = queryParams.toString();
    const url = `/reviews/restaurant/my${queryString ? `?${queryString}` : ''}`;

    const response = await apiClient.get<{
      reviews: Review[];
      total: number;
      page: number;
      limit: number;
    }>(url);

    return response.data.data;
  },

  /**
   * Add restaurant response to review
   */
  async addRestaurantResponse(reviewId: string, response: string): Promise<Review> {
    const responseData = await apiClient.patch<Review>(`/reviews/${reviewId}/response`, {
      response,
    });

    return responseData.data.data;
  },
};

